// サーバレンダリングの公開ページに乗せる振る舞い。
// ページの中身はサーバが描いてあるので、ここは後乗せの飾りだけを持つ。
// JSが動かなくても本文は読めるし、リンクも★以外はそのまま働く。
import { loadEmbeds } from '../lib/useEmbeds'
import { setupLightbox } from '../lib/lightbox'

const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content ?? ''

function setupStars() {
  document.querySelectorAll('[data-piece-star]').forEach((button) => {
    button.addEventListener('click', async () => {
      const pieceId = button.dataset.pieceStar
      const starred = button.getAttribute('aria-pressed') === 'true'
      const next = !starred
      render(button, next)
      if (next) wiggle(button.querySelector('span'))

      try {
        const response = await fetch(`/pieces/${pieceId}/stars`, {
          method: next ? 'POST' : 'DELETE',
          headers: { 'X-CSRF-Token': csrfToken(), Accept: 'application/json' },
        })
        if (!response.ok) render(button, starred)
      } catch {
        render(button, starred)
      }
    })
  })
}

function render(button, starred) {
  button.setAttribute('aria-pressed', String(starred))
  button.setAttribute('aria-label', starred ? 'Remove star' : 'Add star')
  button.classList.toggle('border-gray-400', starred)
  button.classList.toggle('text-amber-400', starred)
  button.classList.toggle('border-gray-200', !starred)
  button.classList.toggle('text-gray-300', !starred)
  button.querySelector('span').textContent = starred ? '★' : '☆'
}

function wiggle(element) {
  if (!element) return
  element.style.animation = 'wiggle 0.5s ease-in-out'
  element.addEventListener('animationend', () => { element.style.animation = 'none' }, { once: true })
}

function setupCopyButtons() {
  document.querySelectorAll('[data-copy-url]').forEach((button) => {
    button.addEventListener('click', async () => {
      await navigator.clipboard.writeText(button.dataset.copyUrl)
      const original = button.innerHTML
      button.innerHTML = '<span class="text-xs text-green-600">✓</span>'
      setTimeout(() => { button.innerHTML = original }, 1500)
    })
  })
}

function setupSearch() {
  const input = document.querySelector('[data-search-input]')
  const panel = document.querySelector('[data-search-results]')
  if (!input || !panel) return

  let timer
  input.addEventListener('input', () => {
    clearTimeout(timer)
    if (input.value.length < 2) { panel.classList.add('hidden'); return }

    timer = setTimeout(async () => {
      const res = await fetch(`/search?q=${encodeURIComponent(input.value)}`)
      const data = await res.json()
      const list = panel.firstElementChild
      list.innerHTML = data.results.map((r) => `
        <a href="${r.url}" class="block py-2 px-2 hover:bg-gray-50 rounded">
          <div class="flex items-center gap-2">
            <span class="text-xs text-gray-400 shrink-0 w-10">${r.entry_type === 'day_piece' ? 'Day' : 'Topic'}</span>
            <span class="text-sm font-medium text-gray-800 truncate">${r.title}</span>
          </div>
          ${r.snippet ? `<p class="text-xs text-gray-500 mt-0.5 ml-12 line-clamp-2">${r.snippet}</p>` : ''}
        </a>`).join('')
      panel.classList.toggle('hidden', data.results.length === 0)
    }, 300)
  })

  document.addEventListener('click', (e) => {
    if (!panel.contains(e.target) && e.target !== input) panel.classList.add('hidden')
  })
}

function setupWiggleOnHover() {
  document.querySelectorAll('[data-wiggle-on-hover]').forEach((element) => {
    element.addEventListener('mouseenter', () => wiggle(element))
  })
}

// devだけ。contentファイルを保存したら、その場で読み直す。
const DEV_RELOAD_INTERVAL_MS = 5000

function setupDevReload() {
  const contentPath = document.body.dataset.contentPath
  if (!import.meta.env.DEV || !contentPath) return

  let known = null
  setInterval(async () => {
    try {
      const res = await fetch(`/dev/content_mtime?path=${encodeURIComponent(contentPath)}&_=${Date.now()}`)
      if (!res.ok) return

      const { mtime } = await res.json()
      if (known === null) known = mtime
      else if (mtime !== known) window.location.reload()
    } catch {
      // 保存の取りこぼしは次の周回で拾えるので黙って見送る
    }
  }, DEV_RELOAD_INTERVAL_MS)
}

setupStars()
setupCopyButtons()
setupSearch()
setupWiggleOnHover()
setupDevReload()
loadEmbeds(document)
setupLightbox()
